import React from "react";
import "./Switch.css";

const Switch = ({ label, name, id, onChange, ...rest }) => {
  const inputId = id || name;

  return (
    <label className="switch-container cursor-pointer" htmlFor={inputId}>
      <input
        type="checkbox"
        className="switch-input"
        id={inputId}
        onChange={(event) => onChange(event)}
        {...rest}
      />
      <span className="switch-slider">
        <span className="switch-thumb"></span>
      </span>
      {label && <span className="switch-label">{label}</span>}
    </label>
  );
};

export default Switch;
